

const Home2View = () =>
  import(
    /*webpackChunkName: "Home2View"*/ "../../../views/sales/Home2View.vue"
  );
export default {
  path: "lp/entertainment-que-nos-une",
  name: "home2",
  alias: ["lp/entretenimiento-que-nos-une"],
  component: Home2View,
  meta: { requiresAuth: false, requiresEntitlement: false },
};
